import React from "react";
import { useParams } from "react-router-dom";
import { useGetMessagesQuery } from "../../features/messages/messagesApi";
import Error from "../Ui/Error";
import ChatHead from "./ChatHead";
import Messages from "./Messages";
import Options from "./Options";

const ChatBody = () => {
    const { id } = useParams();
    const { data, isLoading, isError, error } = useGetMessagesQuery(id);
    const { data: messages, totalCount } = data || {};

    // decide what to render
    let content = null;
    if (isLoading) {
        content = <div className="m-2, text-center">Loading...</div>;
    } else if (!isLoading && isError) {
        content = <Error message={error} />;
    } else if (!isLoading && !isError && messages?.length === 0) {
        content = <div className="m-2, text-center">No messages found !</div>;
    } else if (!isLoading && !isError && messages?.length > 0) {
        content = (
            <>
                <ChatHead message={messages[0]} />
                <Messages messages={messages} totalCount={totalCount} />

                <Options info={messages[0]} />
            </>
        );
    }

    return (
        <div className="w-full lg:col-span-2 lg:block">
            <div className="w-full grid conversation-row-grid">{content}</div>
        </div>
    );
};

export default ChatBody;
